(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 200;

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function renderGroup(title, items, renderItem) {
    if (!items || !items.length) return '';
    var html = '<div class="predictive-search__group">';
    html += '<h3 class="predictive-search__group-title">' + escapeHtml(title) + '</h3><ul>';
    items.forEach(function (item) { html += renderItem(item); });
    html += '</ul></div>';
    return html;
  }

  function renderResults(container, data, term) {
    var results = (data && data.resources && data.resources.results) || {};
    var products = results.products || [];
    var collections = results.collections || [];
    var articles = results.articles || [];
    var queries = results.queries || [];

    var html = '';
    html += renderGroup(window.emdStrings.groupQueries, queries, function (q) {
      return '<li><a href="' + q.url + '">' + q.styled_text + '</a></li>';
    });
    html += renderGroup(window.emdStrings.groupCategories, collections, function (c) {
      return '<li><a href="' + c.url + '">' + escapeHtml(c.title) + '</a></li>';
    });
    html += renderGroup(window.emdStrings.groupGuides, articles, function (a) {
      return '<li><a href="' + a.url + '">' + escapeHtml(a.title) + '</a></li>';
    });
    html += renderGroup(window.emdStrings.groupProducts, products, function (p) {
      var price = p.price ? '<span class="predictive-search__price"> · ' + p.price + '</span>' : '';
      return '<li><a href="' + p.url + '">' + escapeHtml(p.title) + price + '</a></li>';
    });

    if (!html) {
      html = '<p class="predictive-search__empty">' + window.emdStrings.noResults.replace('{{ term }}', escapeHtml(term)) + '</p>';
    }
    container.innerHTML = html;
  }

  function initInstance(root) {
    var input = root.querySelector('[data-predictive-search-input]');
    var results = root.querySelector('[data-predictive-search-results]');
    if (!input || !results) return;

    var currentController = null;

    var search = debounce(function (term) {
      if (term.length < MIN_CHARS) {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        return;
      }
      if (currentController) currentController.abort();
      currentController = window.AbortController ? new AbortController() : null;

      var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'search/suggest.json'
        : '/search/suggest.json';
      url += '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,article,query' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';

      fetch(url, currentController ? { signal: currentController.signal } : {})
        .then(function (res) { return res.json(); })
        .then(function (data) {
          renderResults(results, data, term);
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
        });
    }, DEBOUNCE_MS);

    input.addEventListener('input', function () { search(input.value.trim()); });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.querySelectorAll('[data-predictive-search]').forEach(initInstance);
})();
